import React, { useEffect, useState, useMemo, useRef } from 'react';
import { Button, Form, Modal } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { agGridCommonConfig } from '../config/agGridConfig';
import { AgGridReact } from 'ag-grid-react';
import Loader from './loader';
import { addcategory, editcategory, listcategory, statuscategory, validcategory, viewcategory } from '../service/dataservice';
import { toast } from 'react-toastify';
import imageCompression from "browser-image-compression";

export const Category = () => {
    const nav = useNavigate();
    const { page } = useParams();
    const loader = useRef(false);
    const [show, setShow] = useState(false);
    const [editId, setEditId] = useState(0);
    const [loading, setLoading] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [categoryName, setCategoryName] = useState('');
    const [catfile, setCatFile] = useState(null);
    const [caturl, setCatUrl] = useState('');

    const gridRef = useRef();
    const columnDefs = useMemo(() => [
        {
            headerName: "Actions",
            field: 'id',
            width: 150,
            cellRenderer: (params) => (
                <div className="d-flex justify-content-center">
                    <a
                        className="btn btn-sm btn-primary me-2"
                        onClick={() => handleEdit(params.value)}
                    >
                        <i className="fa fa-edit"></i>
                    </a>

                </div>
            ),
            filter: false,
            sortable: false,
        },
        {
            headerName: "Category",
            field: "category_name",
            floatingFilter: true,
        },
        {
            headerName: "Image",
            field: "category_image",
            cellRenderer: (params) => {
                const image = params.value; // 👈 single value now

                return image ? (
                    <img
                        src={image}
                        alt="category"
                        style={{ height: "40px", width: "40px", objectFit: "cover", borderRadius: "4px" }}
                    />
                ) : (
                    <span>No Image</span>
                );
            },
            filter: false,
            sortable: false,
        },
        {
            headerName: "Status",
            field: "active",
            floatingFilter: true,
            // cellRenderer: (params) => {
            //     const isActive = params.value == "Active";

            //     return (
            //         <div style={{
            //             color: isActive ? "green" : "red",
            //             fontWeight: "600"
            //         }}>
            //             {isActive ? "Active" : "Inactive"}
            //         </div>
            //     );
            // },
            cellRenderer: (params) => (
                <label className="switch">
                    <input
                        type="checkbox"
                        checked={params.value == 1}
                        onChange={() => handleDelete(params.value, params.data.id)}
                    />
                    <span className="slider round"></span>
                </label>
            ),
        },

    ], []);


    useEffect(() => {
        DispLoadData();
    }, [page])

    const DispLoadData = () => {
        setLoading(true);
        let data = new FormData();
        listcategory().then((res) => {
            setLoading(false);
            if (res.status) {
                // const sdata = res.data.map((x) => { return { ...x, active: x.active == 1 ? "Active" : "Inactive" } });
                setRowData(res.data);
            }
            else { toast.error(res.message); }
        })
            .catch((err) => { setLoading(false); toast.error(err.message); });
    }

    const handleEdit = (row) => {
        viewcategory(row).then((res) => {
            if (res.status) {
                setCategoryName(res.data.category_name);
                setEditId(res.data.id);
                setShow(true);
            }
            else toast.error(res.message);
        })
            .catch((err) => toast.error(err.message));
    };


    // 🔴 Delete item
    const handleDelete = (did, eid) => {
        Swal.fire({
            title: `Are you sure want to ${did == 1 ? "Inactive" : "Active"} this category?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            dangerMode: true,
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                const data = new FormData();
                data.append("id", eid);
                data.append("active", did == 1 ? 0 : 1);
                data.append("user_id", localStorage.getItem('user_id'));
                statuscategory(data).then((res) => {
                    setLoading(false);
                    if (res.status) DispLoadData();
                    else toast.error(res.message);
                })
                    .catch((err) => {
                        setLoading(false);
                        toast.error(err.message);
                    });
            }
        });
    };

    const handleShow = () => {
        // setEditMode(false);
        // setCategoryName("");
        setShow(!show);
    };

    const handleClose = () => {
        setShow(false);
        setCategoryName('');
        setCatFile(null);
        setCatUrl('');
        DispLoadData();
        setEditId(0);
    }
    function handleFileChange(event) {
        setCatFile(null);
        setCatUrl('');
        if (event.target.files && event.target.files.length > 0) {
            if (event.target.files[0].name.match(/\.(jpg|jpeg|png)$/i)) {
                const validFiles=event.target.files[0];
                setCatFile(validFiles);
                setCatUrl(URL.createObjectURL(validFiles));
            } else {
                toast.error(event.target.files[0].name + " should be jpg or jpeg or png format")
            }
        }

    }


    const compressImage = async (file) => {
        if (!file) return null;

        const options = {
            maxSizeMB: 0.08, // 20 KB
            useWebWorker: true,
            initialQuality: 0.8,
        };

        try {
            // 1. Compress image
            let compressedFile = await imageCompression(file, options);

            // 2. Optional second pass if still > 500KB
            if (compressedFile.size / 1024 > 500) {
                compressedFile = await imageCompression(compressedFile, {
                    ...options,
                    initialQuality: 0.6,
                });
            }

            // 3. Extract original extension
            const originalName = file.name || "image.jpg";
            const ext = originalName.substring(originalName.lastIndexOf("."));

            // 4. Ensure valid extension fallback
            const safeExt = ext && ext.includes(".") ? ext : ".jpg";

            // 5. Create proper filename
            const newFileName = `${Date.now()}_${Math.random()
                .toString(36)
                .substring(2)}${safeExt}`;

            // 6. Return proper File object (IMPORTANT)
            return new File([compressedFile], newFileName, {
                type: file.type || "image/jpeg",
            });
        } catch (err) {
            console.error("Compression error:", err);

            // fallback with correct filename
            const originalName = file.name || "image.jpg";
            const ext = originalName.substring(originalName.lastIndexOf("."));
            const safeExt = ext && ext.includes(".") ? ext : ".jpg";

            const newFileName = `${Date.now()}_${Math.random()
                .toString(36)
                .substring(2)}${safeExt}`;

            return new File([file], newFileName, {
                type: file.type || "image/jpeg",
            });
        }
    };
    const handleAddCategory = async (e) => {
        e.preventDefault();
        if (!categoryName.trim()) return;

        const temp = new FormData();
        temp.append("category_name", categoryName);
        temp.append("user_id", localStorage.getItem('user_id'));
        if (catfile) {
            const compressedDesktop = await compressImage(catfile);
        temp.append("category_image", compressedDesktop);
        }

        if (editId != 0) {
            temp.append("id", editId);
        }

        try {
            const validateRes = await validcategory({
                name: categoryName,
                id: editId || 0
            });

            if (!validateRes.status) {
                toast.error(validateRes.message);
                return;
            }

            let res;
            if (editId != 0) {
                res = await editcategory(temp);
            } else {
                res = await addcategory(temp);
            }

            if (res.status) {
                toast.success(res.message);
                handleClose();
            } else {
                toast.error(res.message);
            }

        } catch (error) {
            console.error(error);
            toast.error("Something went wrong");
        }
    };

    return (

        <div className="container-fluid mt-4">
            {loading && <Loader />}
            <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h4>Category List</h4>
                    <Button variant="success" onClick={handleShow}>
                        <i className="fa fa-plus me-2"></i> Add Category
                    </Button>
                </div>
                <div className="card-body">
                    <div className="ag-theme-alpine" style={{ height: agGridCommonConfig.tableHeight, width: "100%" }}>
                        <AgGridReact
                            ref={gridRef}
                            rowData={rowData}
                            columnDefs={columnDefs}
                            {...agGridCommonConfig}   // ✅ inject all common settings
                        />
                    </div>
                </div>



                {
                    show ? <Modal show={show} size="lg" onHide={handleClose} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>{editId != 0 ? "Edit" : "Add"} Category</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form.Group className="mb-3" controlId="categoryName">
                                <Form.Label>Category</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Category Name"
                                    value={categoryName}
                                    onChange={(e) => setCategoryName(e.target.value)}
                                    autoFocus
                                />
                            </Form.Group>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="form-label">
                                        Image
                                        {/* <span className="text-danger">*</span> */}
                                    </label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        accept="image/*"
                                        onChange={(e) => handleFileChange(e)}
                                    />
                                    {catfile && (
                                        <div className="mb-3">
                                            <img
                                                src={
                                                    typeof catfile === "string"
                                                        ? catfile
                                                        : URL.createObjectURL(catfile)
                                                }
                                                className="img-fluid"
                                                style={{ maxHeight: "250px", borderRadius: "5px" }}
                                                alt="Category Preview"
                                            />
                                        </div>
                                    )}
                                </div>

                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Cancel
                            </Button>
                            <Button variant="success" type="submit" onClick={handleAddCategory}>
                                {editId != 0 ? "Update" : "Submit"}
                            </Button>
                        </Modal.Footer>
                    </Modal> : null
                }
                {/* Container-fluid ends */}
            </div>

        </div>
    )
}
